<template>
  <v-container fluid>
    <div
      class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-50"
    >
      <div class="md-card md-theme-default">
        <div class="md-card-content">
          <v-row>
            <v-col md="3"><span class="header_title"> Events</span></v-col>
          </v-row>
          <v-row>
            <v-col class="ml-4" cols="2">
              <v-autocomplete
                v-model="searchParams.time_intervel"
                outlined
                label="Time Period"
                @change="changeFxn"
                item-value="name"
                item-text="title"
                :items="timeDuration"
              ></v-autocomplete>
            </v-col>

            <v-col class="ml-1" cols="4" v-if="flag">
              <v-row>
                <v-col cols="5" style="padding-right: 0">
                  <v-menu
                    v-model="menu1"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        outlined
                        background-color="#fff"
                        class="text1"
                        v-model="date1Formatted"
                        readonly
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="searchParams.start_date"
                      @input="menu1 = false"
                    ></v-date-picker>
                  </v-menu>
                </v-col>
                <v-col cols="5">
                  <v-menu
                    v-model="menu2"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        class="text2"
                        v-model="date2Formatted"
                        outlined
                        background-color="#fff"
                        readonly
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="searchParams.end_date"
                      @input="menu2 = false"
                    ></v-date-picker>
                  </v-menu>
                </v-col>
                <v-col cols="2">
                  <v-flex xs1 class="ml-1 mt-1">
                    <v-btn color="#00b0af" height="48" dark @click="getEvents"
                      >Go</v-btn
                    >
                  </v-flex>
                </v-col>
              </v-row>
            </v-col>

            <v-spacer></v-spacer>
            <v-col md="2" class="mr-3">
              <div style="width: 120px; float: right">
                <v-select
                  outlined
                  v-model="perPage"
                  label="Per Page"
                  :items="[10, 15, 25, 50]"
                  @change="getEvents"
                  :menu-props="{ bottom: true, offsetY: true }"
                ></v-select>
              </div>
            </v-col>
          </v-row>
          <div
            class="md-content md-table md-theme-default table_borders"
            table-header-color="orange"
            value
          >
            <div
              class="md-content md-table-content md-scrollbar md-theme-default"
            >
              <table>
                <thead class="md-card-header">
                  <tr>
                    <th class="md-table-head" style="position:relative">
                      <div
                        class="md-table-head-container md-ripple md-disabled"
                      >
                        <div class="md-table-head-label">
                          Timestamp
                        </div>
                        <div class="search_column mt-1">
                          <date-menu
                            v-model="searchParams.date"
                            @change="getFilterData"
                          >
                          </date-menu>
                        </div>
                      </div>
                    </th>

                    <th class="md-table-head">
                      <div
                        class="md-table-head-container md-ripple md-disabled"
                      >
                        <div class="md-table-head-label">
                          Events
                        </div>
                        <div class="search_column">
                          <v-autocomplete
                            solo
                            filled
                            label="event"
                            v-model="searchParams.name"
                            item-value="name"
                            item-text="name"
                            :loading="isLoading"
                            :items="names"
                            :search-input.sync="name"
                            @change="getFilterData"
                          ></v-autocomplete>
                        </div>
                      </div>
                    </th>
                    <th class="md-table-head">
                      <div
                        class="md-table-head-container md-ripple md-disabled"
                      >
                        <div class="md-table-head-label">
                          Venue
                        </div>
                        <div class="search_column">
                          <v-autocomplete
                            solo
                            filled
                            background-color="#fff"
                            v-model="searchParams.venue_id"
                            label="Venue"
                            :items="venues"
                            item-text="name"
                            item-value="id"
                            @change="getEvents"
                          ></v-autocomplete>
                        </div>
                      </div>
                    </th>
                    <th class="md-table-head">
                      <div
                        class="md-table-head-container md-ripple md-disabled"
                      >
                        <div class="md-table-head-label">
                          Service
                        </div>
                        <div class="search_column">
                          <v-autocomplete
                            solo
                            filled
                            background-color="#fff"
                            label="Service"
                            :items="services"
                            item-text="service_name"
                            item-value="id"
                            multiple
                            v-model="searchParams.service_ids"
                            :rules="[(v) => !!v || 'Services is required']"
                            @change="getEvents"
                          >
                            <template
                              v-if="
                                searchParams.service_ids.length ==
                                  services.length
                              "
                              v-slot:selection="{ index }"
                            >
                              <span v-if="index == 0">All Services</span>
                            </template>
                            <template v-else v-slot:selection="{ item, index }">
                              <span v-if="index == 0">{{ item.name }}</span>
                              <span v-if="index == 1">, {{ item.name }}</span>
                              <span v-if="index == 2">, ...</span>
                            </template>

                            <template v-slot:prepend-item>
                              <v-list-item
                                ripple
                                @click="toggle('services', 'service_ids')"
                              >
                                <v-list-item-action>
                                  <v-icon
                                    :color="
                                      searchParams.service_ids.length > 0
                                        ? 'indigo darken-4'
                                        : ''
                                    "
                                    >{{
                                      getIcon("services", "service_ids")
                                    }}</v-icon
                                  >
                                </v-list-item-action>
                                <v-list-item-content>
                                  <v-list-item-title>All</v-list-item-title>
                                </v-list-item-content>
                              </v-list-item>
                            </template>
                          </v-autocomplete>
                        </div>
                      </div>
                    </th>

                    <th class="md-table-head">
                      <div
                        class="md-table-head-container md-ripple md-disabled"
                      >
                        <div class="md-table-head-label">
                          Start Date
                        </div>
                      </div>
                    </th>

                    <th class="md-table-head">
                      <div
                        class="md-table-head-container md-ripple md-disabled"
                      >
                        <div class="md-table-head-label">End Date</div>
                      </div>
                    </th>

                    <th class="md-table-head">
                      <div
                        class="md-table-head-container md-ripple md-disabled"
                      >
                        <div class="md-table-head-label">
                          Make Featured
                        </div>
                      </div>
                    </th>
                  </tr>
                </thead>

                <tbody>
                  <tr
                    class="md-table-row"
                    v-for="data in eventsData"
                    :key="data.id"
                  >
                    <td class="md-table-cell">
                      <div class="md-table-cell-container">
                        {{ data.created_date }}
                      </div>
                    </td>

                    <td class="md-table-cell">
                      <div class="md-table-cell-container">
                        <v-btn
                          @click="
                            $router.push({
                              name: 'ViewEvent',
                              params: { eventId: data.id },
                            })
                          "
                          small
                          color="normal"
                          >{{ data.name != null ? data.name : "NA" }}</v-btn
                        >
                      </div>
                    </td>
                    <td class="md-table-cell">
                      <div class="md-table-cell-container">
                        {{ data.venue != null ? data.venue.name : "NA" }}
                      </div>
                    </td>
                    <td class="md-table-cell">
                      <div class="md-table-cell-container">
                        {{ data.service != null ? data.service.name : "NA" }}
                      </div>
                    </td>

                    <td class="md-table-cell">
                      <div class="md-table-cell-container">
                        {{
                          data.start_date != null
                            ? data.start_date + ":" + data.start_time
                            : "NA" | timeStamp
                        }}
                      </div>
                    </td>
                    <td class="md-table-cell">
                      <div class="md-table-cell-container">
                        {{
                          data.end_date != null
                            ? data.end_date + ":" + data.end_time
                            : "NA" | timeStamp
                        }}
                      </div>
                    </td>

                    <td class="md-table-cell">
                      <v-btn
                        v-if="data.is_featured == 1"
                        small
                        color="success"
                        class="d-inline-block text-truncate"
                        dark
                        @click="changeFeaturedStatus(data.id)"
                      >
                        <span class="text-truncate">Featured</span>
                      </v-btn>
                      <v-btn
                        v-else
                        small
                        color="primary"
                        class="d-inline-block text-truncate"
                        dark
                        @click="changeFeaturedStatus(data.id)"
                      >
                        <span class="text-truncate">Make It Featured</span>
                      </v-btn>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <v-pagination
            v-model="page"
            :length="totalPages"
            :page="page"
            total-visible="10"
          ></v-pagination>
        </div>
      </div>
    </div>

    <Event-model v-bind="EventModel" @close="EventModel.EventID = null" />
    <confirm-model
      v-bind="confirmModel"
      @confirm="confirmActions"
      @close="confirmModel.id = null"
    ></confirm-model>
  </v-container>
</template>
<script>
import moment from "moment";
import EventModel from "./Event/EventModel";
import ConfirmModel from "@/components/Confirmation/ConfirmModel";
export default {
  data() {
    return {
      page: 1,
      names: [],
      name: null,
      totalPages: 1,
      perPage: 10,
      eventsData: [],
      isLoading: false,
      date1: moment()
        .subtract(30, "days")
        .format("YYYY-MM-DD"),
      date2: moment().format("YYYY-MM-DD"),
      flag: false,
      menu1: false,
      menu2: false,
      EventModel: { EventID: null, type: "details" },
      confirmModel: {
        id: null,
        title: null,
        description: null,
      },
      searchParams: {
        timestamp: null,
        start_date: moment()
          .subtract(30, "days")
          .format("YYYY-MM-DD"),
        end_date: moment().format("YYYY-MM-DD"),
        service_ids: [],
        venue_id: null,
        name: null,
      },
      timeDuration: [
        { name: "All", title: "All" },
        { name: "week", title: "This Week" },
        { name: "year", title: "This Year" },
        { name: "month", title: "This Month" },
        { name: "custom", title: "Custom Duration" },
      ],
    };
  },

  components: {
    EventModel,
    ConfirmModel,
  },
  mounted() {
    if (this.$store.getters.getQportalServices.status == false) {
      this.$store.dispatch("loadServices");
    }
    if (this.$store.getters.getQportalVenues.status == false) {
      this.$store.dispatch("loadVenues");
    }
    this.getEvents();
  },
  computed: {
    date1Formatted() {
      return moment(this.date1, "YYYY-MM-DD").format("Do MMM YYYY");
    },
    date2Formatted() {
      return moment(this.date2, "YYYY-MM-DD").format("Do MMM YYYY");
    },
    services() {
      return this.$store.getters.getServices.data;
    },
    venues() {
      return this.$store.getters.getVenues.data;
    },
  },
  watch: {
    page() {
      this.getEvents();
    },
    name(val) {
      if (val == "" || val == null) return;
      if (this.isLoading) return;
      this.filterSearch("name", val);
    },
  },
  methods: {
    getIcon(type, field) {
      let icon = "mdi-checkbox-blank-outline";
      if (this.searchParams[field].length == this[type].length) {
        icon = "mdi-close-box";
      }
      if (
        this.searchParams[field].length > 0 &&
        this.searchParams[field].length != this[type].length
      )
        icon = "mdi-minus-box";

      return icon;
    },
    toggle(type, field) {
      this.$nextTick(() => {
        if (this.searchParams[field].length == this[type].length) {
          this.searchParams[field] = [];
        } else {
          this.searchParams[field] = this[type].map((x) => x.id);
        }
        this.getEvents();
      });
      this.$forceUpdate();
    },
    filterSearch(type, val) {
      if (val == "All") return;
      this.isLoading = true;
      this.$http
        .get("admin/events?field=" + type + "&search=" + val)
        .then((response) => {
          this.isLoading = false;
          if (response.status == 200 && response.data.status) {
            if (type == "name") {
              this.names = response.data.data;
              this.names.unshift(val);
              this.names.unshift("All");
            }
          }
        })

        .catch((error) => {
          this.errorChecker(error);
        });
    },
    getFilterData() {
      this.page = 1;
      this.getEvents();
    },
    showEventModel(EventId) {
      this.EventModel.EventID = parseInt(EventId);
      this.EventModel.type = "details";
    },
    changeFeaturedStatus(id) {
      let msg =
        "This will Change the Featured Status. By clicking Yes you can confirm the operation.";
      this.confirmModel = {
        id: id,
        title: `Do you want to change Featured Status?`,
        description: msg,
      };
    },
    getEvents() {
      let url = "";
      if (
        this.searchParams.service_ids != "All" &&
        this.searchParams.service_ids != null &&
        this.searchParams.service_ids.length > 0
      ) {
        let i = 0;

        this.searchParams.service_ids.forEach(function(item) {
          url += `&category_id[${i}]=${item}`;
          i++;
        });
      }
      if (
        this.searchParams.venue_id != undefined &&
        this.searchParams.venue_id != null
      ) {
        url += "&venue_id=" + this.searchParams.venue_id;
      }
      if (
        this.searchParams.name != "All" &&
        this.searchParams.name != undefined &&
        this.searchParams.name != null
      ) {
        url += "&name=" + this.searchParams.name;
      }
      if (
        this.searchParams.time_intervel != "All" &&
        this.searchParams.time_intervel != null
      ) {
        // this.searchParams.end_date = moment().format("YYYY-MM-DD");
        if (this.searchParams.time_intervel == "custom") {
          this.flag = true;
        } else if (this.searchParams.time_intervel == "week") {
          this.searchParams.start_date = moment()
            .startOf("week")
            .format("YYYY-MM-DD");
        } else if (this.searchParams.time_intervel == "month") {
          this.searchParams.start_date = moment()
            .startOf("month")
            .format("YYYY-MM-DD");
        } else if (this.searchParams.time_intervel == "year") {
          this.searchParams.start_date = moment()
            .startOf("year")
            .format("YYYY-MM-DD");
        }
        url += "&end_date=" + this.searchParams.end_date;
        url += "&start_date=" + this.searchParams.start_date;
      }
      if (this.searchParams.date == null) {
        delete this.searchParams.date;
      } else if (typeof this.searchParams.date != "undefined") {
        url += "&timestamp=" + this.searchParams.date;
      }
      this.showLoader("Loading Events");
      this.$http
        .get(
          "public/events?page=" + this.page + "&per_page=" + this.perPage + url
        )
        .then((response) => {
          this.hideLoader();
          if (response.status == 200 && response.data.status) {
            this.eventsData = response.data.data;
            this.totalPages = response.data.total_pages;
          }
        })
        .catch((error) => {
          this.errorChecker(error);
        });
    },
    changeFxn() {
      if (this.searchParams.time_intervel == "custom") {
        this.searchParams.start_date = moment()
          .subtract(30, "days")
          .format("YYYY-MM-DD");
        this.searchParams.end_date = moment().format("YYYY-MM-DD");
        this.flag = true;
      } else {
        this.flag = false;
        this.getEvents();
      }
    },
    viewEvent(EventId) {
      this.EventID = EventId;
    },
    showeventModel(eventId) {
      this.eventModel.eventId = parseInt(eventId);
      this.eventModel.type = "details";
    },
    confirmActions(data) {
      this.makeItFeatured(data.id);
      this.$forceUpdate();
      this.confirmModel.id = null;
    },
    makeItFeatured(id) {
      this.$http
        .get(`admin/featured-status-change/${id}`)
        .then((response) => {
          if (response.status == 200) {
            this.showSuccess(`Event status Successfully changed.`);
            this.getEvents();
          }
        })
        .catch((error) => {
          this.errorChecker(error);
        });
    },
  },
};
</script>
<style scoped>
.btn_bg {
  background-color: #fff;
  border-bottom: 3px solid #066a8c;
  border-radius: 10px;
  box-shadow: 0 3px 3px -2px black;
}
.mnuBtn {
  padding: 5px;
  font-size: 14px;
  font-weight: 700;
  color: #066a8c;
}
.pickers {
  width: 300px;
}
.text1 .v-input__control {
  border-bottom-right-radius: 0px;
  border-top-right-radius: 0px;
}
.text2 .v-input__control {
  border-bottom-left-radius: 0px;
  border-top-left-radius: 0px;
}
</style>
